<template>
  <p-container class="widget event registration" fill-height>
    <p-row column no-gutters>
      <p-col shrink>
        <h2>{{ $t('core.page.dynamicFormConfiguration.title') }}</h2>
      </p-col>
      <p-col shrink>
        <p-card>
          <p-container>
            <p-row>
              <p-col xs12 sm6 md2 lg1>
                <p-text-field
                  v-model="widgetConfig['widget-app-system']"
                  :label="$t('core.page.dynamicFormConfiguration.appSystemKeyLabel')"
                  required
                  clearable
                ></p-text-field>
              </p-col>
              <p-col xs12 sm6 md4 lg3>
                <p-text-field
                  v-model="widgetConfig['widget-dynamicform-formid']"
                  :label="$t('core.page.dynamicFormConfiguration.formIdLabel')"
                  required
                  clearable
                  pattern="^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
                ></p-text-field>
              </p-col>
              <p-col xs12 sm6 md3 lg2>
                <p-select
                  v-model="widgetConfig.language"
                  :label="$t('core.page.dynamicFormConfiguration.languageSettingsLabel')"
                  :items="languages"
                  clearable
                ></p-select>
              </p-col>
              <p-col xs12 sm6 md4 lg2>
                <p-number-field
                  v-model="widgetConfig['widget-dynamicform-addressownernumber']"
                  type="number"
                  :label="$t('core.page.dynamicFormConfiguration.adressOwnerLabel')"
                  no-steppers
                  clearable
                ></p-number-field>
              </p-col>
              <p-col xs12 sm6 md4 lg2>
                <p-number-field
                  v-model="widgetConfig['widget-dynamicform-businessunit']"
                  type="number"
                  :label="$t('core.page.dynamicFormConfiguration.businessUnitNumberLabel')"
                  no-steppers
                  clearable
                ></p-number-field>
              </p-col>
              <p-col xs12 sm6 md4 lg2>
                <p-text-field
                  v-model="widgetConfig['widget-dynamicform-contactid']"
                  :label="$t('core.page.dynamicFormConfiguration.contactLabel')"
                  clearable
                ></p-text-field>
              </p-col>
              <p-col xs12 sm6 md4 lg5>
                <p-text-field
                  v-model="widgetConfig['widget-submit-redirect-url']"
                  :label="$t('core.page.dynamicFormConfiguration.submitUrlLabel')"
                  clearable
                ></p-text-field>
              </p-col>
              <p-col xs12 sm6 md4 lg2>
                <p-checkbox v-model="showSuccessElement" label="Success" color="success">
                  <p-text-field
                    v-model="widgetConfig['widget-dynamicform-display-success-element-id']"
                    :disabled="!showSuccessElement"
                    label="Erfolg Control Id"
                    clearable
                  ></p-text-field>
                </p-checkbox>
              </p-col>              <p-col xs12 sm6 md4 lg2>
                <p-checkbox v-model="showFailedElement" label="Failes" color="error">
                  <p-text-field
                    v-model="widgetConfig['widget-dynamicform-display-error-element-id']"
                    :disabled="!showFailedElement"
                    label="Fehler Control Id"
                    clearable
                  ></p-text-field>
                </p-checkbox>
              </p-col>
              <p-col :xs12="!$media.isDesktop" :justify-end="!$media.isDesktop" align-end>
                <p-button
                  :disabled="canOpenWidget"
                  @click="openWidget(widgetConfig['widget-dynamicform-formid'],
                                     widgetConfig['widget-app-system'],
                                     showFailedElement ? widgetConfig['widget-dynamicform-display-error-element-id'] : undefined,
                                     showSuccessElement ? widgetConfig['widget-dynamicform-display-success-element-id'] : undefined,
                                     widgetConfig['widget-dynamicform-contactid'],
                                     widgetConfig['widget-dynamicform-businessunit'],
                                     widgetConfig['widget-dynamicform-addressownernumber'],
                                     widgetConfig['widget-submit-redirect-url'],
                                     widgetConfig.language)"
                >
                  {{ $t('core.app.ok') }}
                </p-button>
                <p-button :title="$t('core.page.dynamicFormConfiguration.embed-info')" class="ml-2" secondary @click="toggleWidgetEmbedInfo()">
                  <p-icon :color="isWidgetEmbedInfoVisible ? 'base' : undefined">
                    dataset_linked
                  </p-icon>
                  <p-icon right>
                    {{ isWidgetEmbedInfoVisible ? 'expand_less' : 'expand_more' }}
                  </p-icon>
                </p-button>
              </p-col>
            </p-row>
          </p-container>
        </p-card>
      </p-col>
      <p-card v-if="isWidgetEmbedInfoVisible" class="ma-0">
        <div v-if="!link">
          {{ $t('core.page.dynamicFormConfiguration.embed-info') }}
        </div>
        <template v-else>
          <p-col>
            <p-row align-center nowrap>
              <p-col shrink>
                <a ref="link" :href="link" target="_blank" rel="noopener noreferrer">{{ link }}</a>
              </p-col>
              <p-col grow>
                <p-row dense>
                  <p-button secondary @click="_.copyToClipboard($refs.link)">
                    <p-icon>content_copy</p-icon>
                  </p-button>
                </p-row>
              </p-col>
            </p-row>
          </p-col>
          <p-divider class="mb-4"></p-divider>
          <p-col>
            <p-row>
              <p-col grow>
                <pre ref="widgetEmbedCode" class="code" v-text="addNewLines()"></pre>
              </p-col>
              <p-col shrink>
                <p-button secondary @click="_.copyToClipboard($refs.widgetEmbedCode)">
                  <p-icon>content_copy</p-icon>
                </p-button>
              </p-col>
            </p-row>
          </p-col>
        </template>
      </p-card>
      <template v-if="link">
        <p-col>
          <div ref="widgetContainer">
            <link :href="(`${host}/css/app.css`)" type="text/css">
            <div v-if="widgetConfig['widget-dynamicform-display-success-element-id'] !== undefined" id="divError" class="glitWidgetElementHidden warning">
              Es ist ein Fehler
              passiert...
            </div>
            <div v-if="widgetConfig['widget-dynamicform-display-error-element-id'] !== undefined" id="divSuccess" class="glitWidgetElementHidden success">
              Besten
              Dank!
            </div>
          </div>
          <div id="widgetContainer">
          </div>
          <script
            async="async"
            type="application/javascript"
            data-mount-id="widgetContainer"
            data-router-mode="abstract"
            data-route="_widget/dynamic-form"
            :data-language="widgetConfig.language"
            :data-widget-dynamicform-appsystemkey="widgetConfig['widget-app-system']"
            :data-config-path="(`${host}/`)"
            :data-widget-dynamicform-formid="widgetConfig['widget-dynamicform-formid']"
            :data-widget-dynamicform-display-error-elementid="widgetConfig['widget-dynamicform-display-error-element-id']"
            :data-widget-dynamicform-display-success-elementid="widgetConfig['widget-dynamicform-display-success-element-id']"
            :data-widget-dynamicform-contactid="widgetConfig['widget-dynamicform-contactid']"
            :data-widget-dynamicform-businessunit="widgetConfig['widget-dynamicform-businessunit']"
            :data-widget-dynamicform-addressownernumber="widgetConfig['widget-dynamicform-addressownernumber']"
            :data-widget-submit-redirect-url="widgetConfig['widget-submit-redirect-url']"
            :src="(`${host}/js/app.js`)"
          >
          </script>
        </p-col>
      </template>
    </p-row>
  </p-container>
</template>
<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    data: () => ({
      isWidgetEmbedInfoVisible: false,
      widgetConfig: {
        'mount-id': 'widget-form-id',
        'widget-app-system': 'OM' as string | undefined,
        route: '_widget/dynamic-form',
        language: 'de',
        'widget-dynamicform-formid': undefined as string | undefined,
        'widget-dynamicform-display-error-element-id': 'divError' as string | undefined,
        'widget-dynamicform-display-success-element-id': 'divSuccess' as string | undefined,
        'widget-dynamicform-contactid': undefined as string | undefined,
        'widget-dynamicform-businessunit': undefined as number | undefined,
        'widget-dynamicform-addressownernumber': undefined as number | undefined,
        'widget-submit-redirect-url': undefined as string | undefined,
      },
      link: undefined as string | undefined,
      showFailedElement: false as boolean,
      showSuccessElement: false as boolean,
      host: `${window.location.protocol}//${window.location.host}`,
    }),
    computed: {
      canOpenWidget() {
        return !(this.widgetConfig['widget-app-system'] !== undefined && this.widgetConfig['widget-dynamicform-formid'] !== undefined && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(this.widgetConfig['widget-dynamicform-formid']) && this.widgetConfig['widget-app-system'].length > 0);
      },
      languages() {
        let languages = this.$translation.availableAppLanguages as string[];
        if (languages.length === 0) { languages = ['de', 'en', 'fr', 'it']; }
        return languages.map((lang) => ({
          id: lang.toLowerCase(),
          caption: this.$t(`core.page.language.${lang.toLowerCase()}`),
          description: lang.toLowerCase(),
        }));
      },
    },
    mounted() {
      this.widgetConfig.language = this.$config.getQueryOrValue('language') ?? this.widgetConfig.language ?? 'de';
      this.widgetConfig['widget-dynamicform-formid'] = this.$config.getQueryOrValue('widget-dynamicform-formid', 'formId') ?? this.widgetConfig['widget-dynamicform-formid'];
      this.widgetConfig['widget-dynamicform-display-error-element-id'] = this.$config.getQueryOrValue('widget-dynamicform-display-error-elementid', 'errorElementId') ?? this.widgetConfig['widget-dynamicform-display-error-element-id'] ?? 'divError';
      this.widgetConfig['widget-dynamicform-display-success-element-id'] = this.$config.getQueryOrValue('widget-dynamicform-display-success-elementid', 'successElementId') ?? this.widgetConfig['widget-dynamicform-display-success-element-id'] ?? 'divSuccess';
      this.widgetConfig['widget-dynamicform-contactid'] = this.$config.getQueryOrValue('widget-dynamicform-contactid', 'contactId') ?? this.widgetConfig['widget-dynamicform-contactid'];
      const businessUnit = this.$config.getQueryOrValue('widget-dynamicform-businessunit', 'businessUnit') ?? this.widgetConfig['widget-dynamicform-businessunit'];
      this.widgetConfig['widget-dynamicform-businessunit'] = businessUnit ? Number.parseInt(`${businessUnit}`, 10) : undefined;
      const addressOwnerNumber = this.$config.getQueryOrValue('widget-dynamicform-addressownernumber', 'addressOwnerNumber') ?? this.widgetConfig['widget-dynamicform-addressownernumber'];
      this.widgetConfig['widget-dynamicform-addressownernumber'] = addressOwnerNumber ? Number.parseInt(`${addressOwnerNumber}`, 10) : undefined;
      this.widgetConfig['widget-submit-redirect-url'] = this.$config.getQueryOrValue('widget-submit-redirect-url', 'submitRedirectUrl') ?? this.widgetConfig['widget-submit-redirect-url'] ?? '';
    },
    methods: {
      addNewLines(): string {
        let s = '';
        s += `<link href="${this.host}/css/app.css" type="text/css">
<div id="widgetContainer"></div>
`;
        if (this.showFailedElement) {
          s += `<div id="${this.widgetConfig['widget-dynamicform-display-error-element-id']}">Es ist ein Fehler passiert...</div>
`;
        }
        if (this.showSuccessElement) {
          s += `<div id="${this.widgetConfig['widget-dynamicform-display-success-element-id']}">Besten Dank!</div>
`;
        }
        s += `<script 
  async="async" 
  type="application/javascript"
  data-mount-id="widgetContainer" 
  data-router-mode="abstract"
  data-route="_widget/dynamic-form" 
  data-language="${this.widgetConfig.language}" 
  data-widget-dynamicform-appsystemkey="${this.widgetConfig['widget-app-system']}"
  data-config-path="${this.host}" 
  data-widget-dynamicform-formid="${this.widgetConfig['widget-dynamicform-formid']}"
  `;
        if (this.widgetConfig['widget-dynamicform-addressownernumber']) {
          s += `data-widget-dynamicform-addressownernumber="${this.widgetConfig['widget-dynamicform-addressownernumber']}"
  `;
        }
        if (this.showFailedElement && this.widgetConfig['widget-dynamicform-display-error-element-id']) {
          s += `data-widget-dynamicform-display-error-elementid="${this.widgetConfig['widget-dynamicform-display-error-element-id']}"
  `;
        }
        if (this.showSuccessElement && this.widgetConfig['widget-dynamicform-display-success-element-id']) {
          s += `data-widget-dynamicform-display-success-elementid="${this.widgetConfig['widget-dynamicform-display-success-element-id']}"
  `;
        }
        if (this.widgetConfig['widget-dynamicform-contactid']) {
          s += `data-widget-dynamicform-contactId="${this.widgetConfig['widget-dynamicform-contactid']}"
  `;
        }
        if (this.widgetConfig['widget-dynamicform-businessunit']) {
          s += `data-widget-dynamicform-businessunit="${this.widgetConfig['widget-dynamicform-businessunit']}"
  `;
        }
        if (this.widgetConfig['widget-submit-redirect-url']) {
          s += `data-widget-submit-redirect-url="${this.widgetConfig['widget-submit-redirect-url']}"
  `;
        }
        s += `data-auth-apikey="GL-*****************************"
  src="${this.host}/js/app.js">
<\/script>`;
        return s;
      },

      getDefaultIfUndefined(currentValue:any | undefined, defaultvValue:any) {
        if (currentValue === undefined || currentValue === 'undefined') return defaultvValue;
        return currentValue;
      },
      toggleWidgetEmbedInfo() {
        this.isWidgetEmbedInfoVisible = !this.isWidgetEmbedInfoVisible;
      },
      async openWidget(formId:string, appSystemKey:string, displayErrorElementId:string | undefined, displaySuccessElementId:string | undefined, contactId:string | undefined, businessunit:string | undefined, addressownernumber:number | undefined, redirectUrl:string, language:string) {
        this.$nextTick(() => {
          this.link = undefined;
          const queries = {
            formId, appSystemKey, displayErrorElementId, displaySuccessElementId, contactId, businessunit, addressownernumber, redirectUrl, language,
          } as Record<string, string | undefined>;

          const queryString = Object.keys(queries)
            .filter((key) => queries[key] !== undefined && queries[key] !== null && queries[key] !== '')
            .map((key) => `${key}=${encodeURIComponent(queries[key]!)}`)
            .join('&');
          this.link = new URL(`/_widget/dynamic-form?${queryString}`, document.baseURI).href;
        });
      },

    },
  });
  </script>
  <style lang="scss">
.code {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background-color: lightgray;
  padding: 1%;
  margin: -1%;
  font-size: .8rem;
}
.glitWidgetElementHidden {
  display: none;
}
.glitWidgetElementVisible {
  display: block;
}
</style>
